import { MessageBoxOptionsEnum } from ".";
export interface MessageSearchCriteria {
    searchText?: string;
    pageSize: number;
    pageIndex: number;
    messageStatusId?: number;
    messageStatusName?: string;
    fromRoleId?: number;
    fromRoleName?: string;
    toRoleId?: number;
    toRoleName?: string;
    contextJobId?: number;
    contextJobName?: string;
    contextUserId?: number;
    contextUserName?: string;
    sortField: string;
    sortDir: SortDir;
    box: string;
}

export const defaultMessageSearchCriteria: MessageSearchCriteria = {
    searchText: "",
    pageIndex: 1,
    pageSize: 25,
    sortField: "createTimestamp",
    sortDir: "desc",
    box: MessageBoxOptionsEnum.Inbox.name,
};
